<template>
    <MainContentSearchable title="Listado de abonados" id="abonados" v-model="filtros" :meta="abonados.meta" @updated="debouncedGetAbonados">
        <template v-slot:header>
            <b-row style="width: 100%">
                <b-col cols="12" class="mb-4 pr-0 mr-0">
                    <SelectListaComponent
                        v-model="lista_abonados"
                        @input="getAbonados"
                    />
                </b-col>
                <b-col sm="12" md="6" class="mb-2 pb-1">
                    <Button id="add-abonado" class="crearAbonado" icon="fas fa-plus" @click="showModal('addAbonado')">Añadir nuevo abonado</Button>
                    <router-link :to="{ name: 'back.abonos.informe' }" class="btn btn-primary ml-1" v-if="permisos['abonos.informe'] && manager.lfp"><i class="fas fa-chart-bar"></i>VENTAS</router-link>
                    <AddAbonado
                        :lista_abonado="lista_abonados"
                        v-on:close="closeModalAnular"
                    />
                </b-col>
                <b-col sm="12" md="6" class="text-right mb-2 pb-1 mr-0 pr-0">
                    <Button class="ml-1" icon="far fa-envelope" @click="showModal('enviar-abonos')">Enviar</Button>
                    <EnviarAbonos
                        :searchParams="searchParams()"
                        v-on:close="closeModal"
                    />
                    <Button class="ml-1" icon="fa fa-print" target="_blank" :href="url_imprimir_abonos" :disabled="!url_imprimir_abonos" >Imprimir</Button>
                    <Button class="ml-1" icon="fa fa-download" @click="showModal('descargar-abonados')">Descargar</Button>
                    <DescargarListaAbonados
                        :searchParams="searchParams()"
                        name="descargar-abonados"
                        v-on:close="closeModal"
                    />
                </b-col>
            </b-row>
        </template>

        <template v-slot:extra-options>
            <div class="col-12 col-lg-9 pr-0 mr-0">
                <div class="input-group-sm my-3">
                    <select class="custom-select w-auto mr-2" id="search" v-model="filtros.search_for" @change="debouncedGetAbonados()">
                        <option value="">Buscar por</option>
                        <option value="n_abonado">Nº Abonado</option>
                        <option value="dni">Dni</option>
                        <option value="nombre_apellidos">Nombre y Apellidos</option>
                        <option value="penista">Peña / Empresa</option>
                        <option value="email">Email</option>
                        <option value="telefono">Teléfono</option>
                        <option value="taquillero">Taquillero/a</option>
                    </select>

                    <select class="custom-select w-auto tipo-abono-width mr-2" v-model="filtros.tipo_abono" @change="debouncedGetAbonados(); filtros.tipo_precio=''">
                        <option value="">Tipo de abono</option>
                        <option v-for="tipo_abonado in tipos_abono" :value="tipo_abonado" :key="tipo_abonado.id">{{tipo_abonado.descripcion}} <span v-if="tipo_abonado.renovacion == 1"> (renovación)</span> </option>
                    </select>

                    <select class="custom-select w-auto mr-2" :disabled="!filtros.tipo_abono.descuentos" v-model="filtros.tipo_precio" @change="debouncedGetAbonados()">
                        <option value="">Tipo de precio</option>
                        <option v-for="descuento_abonado in filtros.tipo_abono.descuentos" :value="descuento_abonado" :key="descuento_abonado.id">{{ descuento_abonado.descripcion }}</option>
                    </select>

                    <select class="custom-select w-auto mr-2" v-model="filtros.metodo_pago_id" @change="debouncedGetAbonados()">
                        <option value="">Método de pago</option>
                        <option v-for="metodo_pago in metodos_pago" :value="metodo_pago.id" :key="metodo_pago.id">{{ metodo_pago | formatear_metodo_pago }}</option>
                    </select>

                    <select class="custom-select w-auto mr-2" v-model="filtros.tipo" @change="debouncedGetAbonados()">
                        <option value="">Selecciona tipo</option>
                        <option value="0">Normal</option>
                        <option value="1" v-if="configuracion.simpatizante">{{ configuracion.simpatizante.charAt(0).toUpperCase() + configuracion.simpatizante.slice(1) }}</option>
                    </select>

                    <select class="custom-select w-auto mr-2" v-model="filtros.activos" @change="debouncedGetAbonados()">
                        <option value="">Estado</option>
                        <option value="1">Activos</option>
                        <option value="0">Inactivos</option>
                    </select>
                </div>
            </div>
        </template>
       
        <template v-slot:content>
            <div v-if="abonados" :class="['table', { 'expanded': abonados.data?.length <= 6 }]">
                <b-table hover :items="abonados.data" :busy="loading" :fields="fields" id="abonados-table">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <ContentOrLoading style="height: 100px"/>
                        </div>
                    </template>
                    <template #cell(esta_renovado)></template>

                    <template #cell(nombreapellidos)="data">
                        {{data.item.name}} {{data.item.surnames}}
                    </template>

                    <template #cell(id)="data">
                        <OpcionesDropdownTableComponent
                            :lastIndex="abonados.data?.length > 6 && data.index >= abonados.data?.length - 3"
                            v-bind:options="[
                                ...(teatro.hash === 'XSb8uxOmqRUI9fMC3Kos' ? [{ type: 'action', action:() => modificarEstadoAbono(data.value), label: data.item.esta_renovado ? 'Anular' : 'Activar'}] : []),
                                { to: { name: 'back.abonados.show', params: { lista_id: lista_abonados.id, abonado_id: data.value }}, label: 'Ver ' + (data.item.tipo ? teatro.texto_simpatizante : teatro.texto_abonado)},
                                ... data.item.user_id ?
                                    [{ to: { name: 'back.usuarios.show-user', params: { lista_id: lista_abonados.id, user_id: data.item.user_id }}, label: 'Ver usuario'}]
                                    : [],
                                { type: 'action', action:() => enviarAbono(data.value), label: 'Enviar ' + (data.item.tipo ? teatro.texto_simpatizante : teatro.texto_abono)},
                                { type: 'url', url: data.item.url_descargar + '&tid=' + configuracion.hash_teatro, label: 'Descargar ' + (data.item.tipo ? teatro.texto_simpatizante : teatro.texto_abono)},
                                ... data.item.esta_renovado && !manager.lfp ? [
                                    { to: { name: 'back.abonados.editar', params: { lista_id: lista_abonados.id, abonado_id: data.value }, query: filtros }, label: 'Editar ' + (data.item.tipo ? teatro.texto_simpatizante : teatro.texto_abonado)},
                                    { type: 'url', url: data.item.url_imprimir, label: 'Imprimir ' + (data.item.tipo ? teatro.texto_simpatizante : teatro.texto_abono)},
                                    { type: 'url', url: data.item.url_recibo + '&tid=' + configuracion.hash_teatro, label: 'Imprimir recibo'},
                                    { type: 'url', url: data.item.url_imprimir + '&cambiar_qr=true', label: 'Reimpresión perdida'},
                                    { to: { name: 'back.abonados.show', params: { lista_id: lista_abonados.id, abonado_id: data.value}}, label: 'Sanciones'},
                                    { to: { name: 'back.abonados.liberar.asiento', params: {lista_id: lista_abonados.id, abonado_id: data.value}}, label: 'Liberar asiento'},
                                    ... permisos['abonos.devolver'] ? [{ type: 'action', action:() => showModal('anular-' + data.value), label: 'Realizar devolución'}] : []
                                ] : [],
                                ... !data.item.esta_renovado && permisos['abonos.devolver'] ? [{ type: 'action', action:() => showModal('borrar-' + data.value), label: 'Borrar ' + (data.item.tipo ? teatro.texto_simpatizante : teatro.texto_abonado)}] : []
                            ]"
                        />
                        <AnularAbono :abonado="data.item" v-on:close="closeModalAnular"/>
                        <BorrarAbono :abonado="data.item" v-on:close="closeModalAnular"/>
                    </template>
                
                </b-table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import AnularAbono from './modals/AnularAbono';
    import BorrarAbono from './modals/BorrarAbono';
    import EnviarAbonos from './modals/EnviarAbonos';
    import AddAbonado from './modals/AddAbonado.vue';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
    import DescargarListaAbonados from "./modals/DescargarListaAbonados";
    import SelectListaComponent from "@/components/backend/components/listas_abonados/SelectListaComponent.vue";



    export default {
        data() {
            return {
                abonados: { meta: {}},
                tipos_abono: [],
                metodos_pago : [],
                loading: true,
                filtros: {
                    per_page: this.$route.query.per_page ?? 10,
                    page: this.$route.query.page ?? 1,
                    search: this.$route.query.search ?? "",
                    search_for: this.$route.query.search_for ?? "",
                    tipo: this.$route.query.tipo ?? 0,
                    metodos_pago: this.$route.query.metodos_pago ?? [],
                    metodo_pago_id: this.$route.query.metodo_pago_id ?? "",
                    tipo_abono: this.$route.query.tipo_abono ?? "",
                    tipo_precio: this.$route.query.tipo_precio ?? "",
                    taquillero: this.$route.query.taquillero ?? "",
                    activos: this.$route.query.activos ?? "",
                },
                fields: [
                    { key: 'esta_renovado', label: '', tdClass: this.estaRenovadoCellClass },
                    { key: 'n_abonado', label: 'Nº de abonado'},
                    'origen',
                    'dni',
                    { key: 'nombreapellidos', label: 'Nombre' },
                    'email',
                    { key: 'id', label: 'opciones', class: 'text-center' }
                ],
                descarga: {
                    status: 0
                },
                lista_abonados: null
            }
        },
        created() {
            this.lista_abonados = this.$store.getters.getListaActiva;
            this.getTiposAbono();
            this.debouncedGetAbonados = _.debounce(this.updateURL, 500);
            this.getMetodosPago();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            url_imprimir_abonos() {
                if(this.abonados && this.abonados.data && this.abonados.data.length > 0) {
                    const abonadosIds = this.abonados.data.map(ab => ab.id).join(',');
                    const query = new URLSearchParams(abonadosIds ? { abonados: abonadosIds } : {}).toString();

                    return this.config.API_BASE + '/abonados/abonos/imprimir-busqueda?api_key=' + localStorage.getItem('token') + "&" + query + '&tid=' + this.configuracion.hash_teatro;
                }

                return '';
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            enviarAbono(id) {
                const params = {
                    filters : {},
                    abonado_id: id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.abono.enviar'), params).then(res => {
                    this.$toast.success("Abono enviado");
                });
            },
            getAbonados : function() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.index'), this.searchParams()).then(res => {
                    this.abonados = res.data;
                    this.abonados.data = this.abonados.data.filter(ab => ab.n_abonado !== -10);
                }).finally(() => this.loading = false);
            },
            getTiposAbono() {
                const params = {
                    filters : {
                        lista_abonado_id: this.lista_abonados.id
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.tipos.abonos'), params).then(res => {
                    this.tipos_abono = res.data.tipos_abonado;
                    if (this.$route.query.tipo_abono) {
                        this.filtros.tipo_abono =  this.tipos_abono.find(tipo => tipo.id == this.$route.query.tipo_abono);
                    }
                    if (this.$route.query.tipo_precio) {
                        this.filtros.tipo_precio =  this.filtros.tipo_abono.descuentos.find(descuento => descuento.id == this.$route.query.tipo_precio);
                    }
                }).finally(() => this.getAbonados());
            },
            getMetodosPago() {
                const params = {
                    filters : {
                        lista_abonado_id: this.lista_abonados.id
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.metodos-pago'), params).then(res => {
                    this.metodos_pago = res.data.metodos_pago;
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            closeModalAnular(modal, anulado) {
                this.$modal.hide(modal);
                if(anulado) {
                    this.getAbonados();
                }
            },
            estaRenovadoCellClass(value, key, item) {
                switch (value) {
                    case 1:
                        return 'bg-green';

                    case 2:
                        return 'bg-info';

                    default:
                        return 'bg-red';
                }
            },
            searchParams() {

                const params = {
                    filters : {
                        per_page: this.filtros.per_page,
                        page: this.filtros.page,
                        tipo: this.filtros.tipo,
                        lista_abonado_id: this.lista_abonados.id
                    },
                    lista_id:  this.lista_abonados.id
                };

                if(this.filtros.search_for !== "") {
                    params.filters[this.filtros.search_for] = this.filtros.search;
                }

                if(this.filtros.metodo_pago_id) {
                    params.filters.metodo_pago = this.filtros.metodo_pago_id;
                }

                if(this.filtros.tipo_abono && this.filtros.tipo_abono.id) {
                    params.filters.tipo_abono = this.filtros.tipo_abono.id;
                }

                if(this.filtros.tipo_precio && this.filtros.tipo_precio.id) {
                    params.filters.tipo_precio = this.filtros.tipo_precio.id;
                }

                if(this.filtros.taquillero) {
                    params.filters.taquillero = this.filtros.taquillero;
                }

                if(this.filtros.activos !== "") {
                    params.filters.activos = this.filtros.activos;
                }

                return params;
            },

            updateURL(){
                var query = {
                    per_page : this.filtros.per_page,
                    page : this.filtros.page,
                }
                if(this.filtros.search != '') {
                    query.search = this.filtros.search;
                }

                if(this.filtros.search_for != '') {
                    query.search_for = this.filtros.search_for;
                }

                if(this.filtros.tipo != '') {
                    query.tipo = this.filtros.tipo;
                }

                if(this.filtros.metodos_pago) {
                    query.metodos_pago = this.filtros.metodos_pago;
                }

                if(this.filtros.metodo_pago_id != '') {
                    query.metodo_pago_id = this.filtros.metodo_pago_id;
                }

                if(this.filtros.tipo_abono != '') {
                    query.tipo_abono = this.filtros.tipo_abono.id;
                }

                if(this.filtros.tipo_precio != '') {
                    query.tipo_precio = this.filtros.tipo_precio.id;
                }

                if(this.filtros.taquillero != '') {
                    query.taquillero = this.filtros.taquillero;
                }

                if(this.filtros.activos != '') {
                    query.activos = this.filtros.activos;
                }

                this.$router.push({ path: '/admin/abonados', query: query }).finally(() => this.getAbonados());
            },
            modificarEstadoAbono(abonado_id) {
                const params = {
                    filters : {},
                    abonado_id: abonado_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.abono.modificar-estado'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getAbonados();
                });
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, AnularAbono, EnviarAbonos, BorrarAbono, AddAbonado, DescargarListaAbonados, SelectListaComponent, 
        }
    }
</script>

<style scoped>
    .table {
        overflow: auto;
    }
    .table.expanded {
        padding-bottom: 150px !important;
    }
    @media (max-width: 700px) {
        .crearAbonado {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 5px;
        }
        
        .ml-1 {
            margin-bottom: 5px;
            margin-right: 5px;
            float: left;
        }

        .mr-3 {
            margin-bottom: 10px;
            margin-right: 5px;
            float: left;
        }

        .tipo-abono-width {
            width: 100% !important;
        }
    }
</style>